import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Carte des blessures", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUploader = _resolveComponent("FileUploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_FileUploader, {
      file: _ctx.state,
      "onUpdate:file": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state) = $event))
    }, null, 8, ["file"])
  ]))
}